<script>
import { mapState, mapActions } from 'vuex';
/* components */
import Spinner from '@/components/Spinner';
import FillProfile from '@/blocks/onboarding/FillProfile';
import ConnectGame from '@/blocks/onboarding/ConnectGame';
import GamePlatform from '@/blocks/onboarding/GamePlatform';
import SpecifyGame from '@/blocks/onboarding/SpecifyGame';
import ConnectSteam from '@/blocks/onboarding/ConnectSteam';
import InstructionsExecuted from '@/blocks/onboarding/InstructionsExecuted';
import FollowInstructions from '@/blocks/onboarding/FollowInstructions';
/* tools */
import {} from '@/scripts/utils';
import { getGameInstructions } from '@/scripts/api/games';
import { gameSetup } from '@/scripts/computed';
import { goTo } from '@/scripts/methods';

export default {
  name: 'Onboarding',
  components: {
    FillProfile,
    ConnectGame,
    GamePlatform,
    SpecifyGame,
    ConnectSteam,
    InstructionsExecuted,
    FollowInstructions,
    Spinner,
  },
  props: {
    show: {
      type: Boolean,
      default: !false,
    },
  },
  data() {
    return {
      platform: null,
      activeGame: null,
      gameInstructions: null,
      /*  */
      forcedParams: null,
      blockView: false,
      userInput: '',
    };
  },
  watch: {
    pathState(val) {
      /* reset platform */
      if (val === 'connect-game') {
        this.platform = null;
      }
    },
  },
  computed: {
    ...mapState(['user', 'games']),
    pathState() {
      const { $route: route = null } = this;
      const result = route.params.option;

      return result;
    },
    onlySteam() {
      const { gameSetup = {} } = this;
      const { platforms = [] } = gameSetup;
      const haveSteam = platforms.some(({ id }) => id === 'steam');
      const result = platforms.length === 1 && haveSteam;

      return result;
    },
    stemSelected() {
      const { platform } = this;
      const result = platform === 'steam';

      return result;
    },
    gameSetup,
  },
  created() {
    this.checkForceSettings();
  },
  mounted() {},
  methods: {
    ...mapActions({}),
    checkForceSettings() {
      const { $route: route } = this;
      const { game } = route.params;

      if (!game) return;

      const urlParams = new URLSearchParams(window.location.search);
      const platform = urlParams.get('platform');

      this.forcedParams = { game, platform };

      this.setGame(game, platform);
    },
    setPlatform(id) {
      this.platform = id;
    },
    setGame(id, platform = null) {
      /* if (this.activeGame !== id) {
      } */
      this.activeGame = id;
      this.platform = platform;
      this.gameInstructions = null;

      this.checkInstructions();
    },
    checkInstructions() {
      const {
        platform,
        // gameInstructions,
        gameSetup,
        onlySteam,
        stemSelected,
      } = this;
      const {
        connectionPerPlatform,
        platformSelectionRequired,
        /* platforms, */
      } = gameSetup;
      const forceSetPlatform =
        (platformSelectionRequired && !onlySteam) || connectionPerPlatform;

      if (onlySteam) {
        this.platform = 'steam';
        this.getGameInstructions({ follow: true });
        /* this.getGameInstructions({ redirect: '/onboarding/connect-steam' }); */
      } else if (platform) {
        this.getGameInstructions({ follow: true });
      } else if (forceSetPlatform) {
        this.goTo('/onboarding/game-platform');
      } else if (stemSelected) {
        this.getGameInstructions({ follow: true });
        /* this.getGameInstructions({ redirect: '/onboarding/connect-steam' }); */
      } else {
        this.getGameInstructions({ follow: true });
      }
    },
    getGameInstructions(params = {}) {
      const { activeGame, platform, forcedParams } = this;
      const { redirect = '', follow = false } = params;

      if (this.forcedParams) this.blockView = true;

      return getGameInstructions(activeGame, platform)
        .then(data => {
          this.blockView = false;

          this.gameInstructions = {
            ...data,
            _gameType: activeGame,
            _platform: platform,
          };

          /* redirects */
          const params = { method: forcedParams ? 'replace' : 'push' };

          if (follow) {
            let path = this.getFollowNextStep();

            this.goTo(path, params);
          } else if (redirect) {
            this.goTo(redirect, params);
          }
        })
        .catch(() => {
          this.blockView = false;
        });
    },
    getFollowNextStep(currentRoute) {
      let result = '/onboarding/connect-game';
      const { gameInstructions, onlySteam, stemSelected } = this;

      if (!gameInstructions) return result;

      const { accountForm, instructionsForm, thankYouNote } = gameInstructions;

      if (
        currentRoute === 'follow-instructions' &&
        (onlySteam || stemSelected)
      ) {
        result = '/onboarding/connect-steam';
      } else if (
        accountForm &&
        currentRoute !== 'specify-game' &&
        currentRoute !== 'follow-instructions'
      ) {
        result = '/onboarding/specify-game';
      } else if (instructionsForm && currentRoute !== 'follow-instructions') {
        result = '/onboarding/follow-instructions';
      } else if (thankYouNote) {
        result = '/onboarding/instructions-executed';
      }

      return result;
    },
    goTo,
  },
};
</script>

<template>
  <div class="root">
    <!-- preloader -->
    <Spinner v-if="blockView" :show="true" />
    <!--  -->

    <ConnectGame v-else-if="pathState === 'connect-game'" @change="setGame" />

    <!--  -->
    <GamePlatform
      v-else-if="pathState === 'game-platform'"
      :activeGame="activeGame"
      :platform="platform"
      @change="setPlatform"
      @next="() => getGameInstructions({ follow: true })"
    />

    <!--  -->
    <SpecifyGame
      v-else-if="pathState === 'specify-game'"
      :activeGame="activeGame"
      :platform="platform"
      :userInput="userInput"
      :linkTo="getFollowNextStep('specify-game')"
      :setup="gameInstructions"
      @at-input="val => (userInput = val)"
    />

    <!--  -->
    <ConnectSteam
      v-else-if="pathState === 'connect-steam'"
      :activeGame="activeGame"
      :platform="platform"
      :linkTo="getFollowNextStep('specify-game')"
    />

    <!--  -->
    <FollowInstructions
      v-else-if="pathState === 'follow-instructions'"
      :activeGame="activeGame"
      :platform="platform"
      :userInput="userInput"
      :linkTo="getFollowNextStep('follow-instructions')"
      :setup="gameInstructions"
    />

    <!--  -->

    <InstructionsExecuted
      v-else-if="pathState === 'instructions-executed'"
      :activeGame="activeGame"
      :platform="platform"
      :setup="gameInstructions"
    />

    <!--  -->
    <FillProfile v-else-if="user" :user="user" />
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
</style>
